import React, { Component } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { parseString } from "xml2js";
import _ from "lodash";
import api from "../../api";
import settings from "../../settings";
import PersonDetail from "./PersonDetail";
import CriminalReportSection from "./CriminalReportSection";
import BankruptciesLiensJudgmentsReportSection from "./BankruptciesLiensJudgmentsReportSection";
import EmailReportSection from "./EmailReportSection";
import NeighborsReportSection from "./NeighborsReportSection";
import RelativesReportSection from "./RelativesReportSection";
import CommonResidencyReportSection from "./CommonResidencyReportSection";
import CriminalRecordsSecondarySection from "./CriminalRecordsSecondarySection";
import SsnVerificationSection from "./SsnVerificationSection";
import DemographicsSection from "./DemographicsSection";
import PropertiesSection from "./PropertiesSection";
import SocialMediaSection from "./SocialMediaSection";
import MotorVehicleReportSection from "./MotorVehicleReportSection";
import {
  stickyNavInitialize,
  stickyNavInitializeContext,
} from "../../actions/stickyNavAction";
import PlatinumAddressHistory from "../reports/Platinum/PlatinumAddressHistory";
import PropertyDataSection from "./PropertyDataSection";

class PersonReport extends Component {
  constructor(props) {
    super(props);
    this.reportRefs = [];
    const { internalID, savedResultID, internalNameID } = props.additionalData;
    this.state = {
      savedResultID,
      internalID,
      internalNameID,
    };
  }

  componentDidMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.currentIndex !== undefined) {
      this.onReportIndexChanged(nextProps.currentIndex);
    }
    if (nextProps.additionalData !== null) {
      const {
        internalID,
        savedResultID,
        internalNameID,
      } = nextProps.additionalData;
      if (
        this.state.internalID !== internalID ||
        this.state.savedResultID !== savedResultID ||
        this.state.internalNameID !== internalNameID
      ) {
        this.setState({ internalID, savedResultID, internalNameID });
        this.loadData(nextProps);
      }
    }
  }

  onReportIndexChanged = (currentIndex) => {
    const reportRef = this.reportRefs[
      currentIndex < this.reportRefs.length ? currentIndex : 0
    ];
    const section = ReactDOM.findDOMNode(reportRef.current);
    if (section !== undefined && section !== null) {
      section.scrollIntoView();
    } else if (this.state.navs && this.state.navs.length > currentIndex) {
      const nav = this.state.navs[currentIndex];
      const element = document.getElementById(`nav_${nav.name}`);
      if (element) element.scrollIntoView();
    }
  };

  loadMartinRecord = (props) => {
    const martinNode = _.get(props.reportData, "personReport.martin[0]");
    if (martinNode) {
      const martinRecord = _.get(props.reportData, "personReport.martin[0]");
      this.setState({ martinRecord });
    } else {
      const additionalData = _.cloneDeep(props.additionalData);
      additionalData.requestedSection = "martin";
      api.report
        .person(additionalData)
        .then((res) => {
          parseString(res.data, { async: false }, (err, rslt) => {
            const martinRecord = _.get(rslt, "personReport.martin[0]");
            this.setState({ martinRecord });
          });
        })
        .catch((err) => console.log("demographics res error - ", err));
    }
  };

  loadData = (props) => {
    const navs = [];
    this.reportRefs = [];
    let reportTypes = settings.compDefaultReportTypes;
    if (
      props.additionalData !== undefined &&
      props.additionalData.optReportType === "compplus"
    ) {
      reportTypes = settings.compPlusDefaultReportTypes;
    }
    const navRefMap = {};
    const defRef = React.createRef();
    navRefMap[settings.defaultSection.sectionName] = {
      name: settings.defaultSection.sectionName,
      display: settings.defaultSection.displayName,
      ref: defRef,
    };
    navs.push({
      name: settings.defaultSection.sectionName,
      display: settings.defaultSection.displayName,
      count: undefined,
    });
    this.reportRefs.push(defRef);

    _.forEach(settings.sectionReports, (rep) => {
      if (_.findIndex(reportTypes, (a) => a === rep.sectionName) !== -1) {
        const ref = React.createRef();
        navRefMap[rep.sectionName] = {
          name: rep.sectionName,
          display: rep.displayName,
          ref,
        };
        navs.push({
          name: rep.sectionName,
          display: rep.displayName,
          count: undefined,
        });
        this.reportRefs.push(ref);
      }
    });

    const addonReports = props.additionalData.selectedReports
      ? props.additionalData.selectedReports
      : [];
    _.forEach(settings.addOnReports, (addonReport) => {
      const addonNode = _.get(
        props.reportData,
        `personReport.${addonReport.sectionName}s[0]`
      );
      if (addonNode) {
        addonReports.push(addonReport.sectionName);
      }
    });
    const addonReportSections = [];
    if (addonReports !== undefined && addonReports.length > 0) {
      const addOnref = React.createRef();
      navRefMap.addonrepsep = {
        name: "addonrepsep",
        display: "Add On Reports",
        ref: addOnref,
      };
      navs.push({
        name: "addonrepsep",
        display: "Add On Reports",
        count: undefined,
      });
      this.reportRefs.push(addOnref);
      _.forEach(settings.addOnReports, (rep) => {
        if (_.findIndex(addonReports, (a) => a === rep.sectionName) !== -1) {
          const ref = React.createRef();
          navRefMap[rep.sectionName] = {
            name: rep.sectionName,
            display: rep.displayName,
            ref,
            count: undefined,
          };
          this.reportRefs.push(ref);
          navs.push({
            name: rep.sectionName,
            display: rep.displayName,
            count: undefined,
          });
        }
      });
      const personResult = _.get(props.reportData, "personReport.person[0]");
      if (addonReports.length > 0) {
        for (let i = 0; i < addonReports.length; i += 1) {
          if (addonReports[i] === "crimaddon") {
            addonReportSections.push(
              <CriminalReportSection
                {...props}
                node={personResult}
                sectionName={navRefMap.crimaddon.name}
                updateItemCountBySection={this.updateItemCountBySection}
                key={`addon_${i}`}
              />
            );
          } else if (addonReports[i] === "bljaddon") {
            addonReportSections.push(
              <BankruptciesLiensJudgmentsReportSection
                {...props}
                node={personResult}
                sectionName={navRefMap.bljaddon.name}
                updateItemCountBySection={this.updateItemCountBySection}
                key={`addon_${i}`}
              />
            );
          } else if (addonReports[i] === "mvraddon") {
            addonReportSections.push(
              <MotorVehicleReportSection
                {...props}
                node={personResult}
                sectionName={navRefMap.mvraddon.name}
                updateItemCountBySection={this.updateItemCountBySection}
                key={`addon_${i}`}
              />
            );
          } else if (addonReports[i] === "mvraddonplat") {
            addonReportSections.push(
              <MotorVehicleReportSection
                {...props}
                node={personResult}
                sectionName={navRefMap.mvraddonplat.name}
                updateItemCountBySection={this.updateItemCountBySection}
                key={`addon_${i}`}
              />
            );
          }
        }
      }
    }
    const { internalID, savedResultID } = props.additionalData;
    this.setState({
      reportTypes,
      navRefMap,
      addonReportSections,
      internalID,
      savedResultID,
      navs,
    });
    this.loadMartinRecord(props);
    const stickyNav = props.stickyNav;
    stickyNav.navs = navs;
    props.stickyNavInitialize(stickyNav);
  };

  updateItemCountBySection = (sectionName, count, isSecondaryCount = false) => {
    const stickyNav = this.props.stickyNav;
    const navs = stickyNav.navs;
    const currentSection = _.find(navs, (n) => n.name === sectionName);
    if (currentSection !== undefined) {
      if (isSecondaryCount) {
        currentSection.secCount = count;
      } else {
        currentSection.count = count;
      }
    }
    stickyNav.navs = navs;

    this.props.stickyNavInitializeContext(stickyNav);
  };

  render() {
    const { reportData } = this.props;
    const personResult = _.get(reportData, "personReport.person[0]");
    let navRefMapLength = 0;
    if (this.state !== null && this.state.navRefMap !== undefined) {
      navRefMapLength = Object.keys(this.state.navRefMap).length;
    }
    return (
      <div ref={this.props.stickyNav.handleContextRef} id={`report`}>
        {this.state && this.state.navRefMap && (
          <div>
            <PersonDetail
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap[settings.defaultSection.sectionName]
                      .ref
                  : undefined
              }
              {...this.props}
            />
            <PlatinumAddressHistory
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.addresshistory.ref
                  : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.addresshistory.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <SsnVerificationSection
              {...this.props}
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.ssnverification.ref
                  : undefined
              }
              node={personResult}
              sectionName={this.state.navRefMap.ssnverification.name}
              updateItemCountBySection={this.updateItemCountBySection}
              martinRecord={this.state.martinRecord}
            />
            <PropertyDataSection
              {...this.props}
              ref={
                navRefMapLength > 0
                  ? this.state.navRefMap.properties.ref
                  : undefined
              }
              node={personResult}
              sectionName={this.state.navRefMap.properties.name}
              updateItemCountBySection={this.updateItemCountBySection}
              martinRecord={this.state.martinRecord}
              isSecondaryCount
            />
            <CommonResidencyReportSection
              {...this.props}
              sectionName={this.state.navRefMap.commonresidency.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <CriminalRecordsSecondarySection
              {...this.props}
              ref={
                this.reportRefs !== undefined ? this.reportRefs[4] : undefined
              }
              node={personResult}
            />
            <DemographicsSection
              {...this.props}
              ref={
                this.reportRefs !== undefined ? this.reportRefs[5] : undefined
              }
              node={personResult}
              sectionName={this.state.navRefMap.demo.name}
              updateItemCountBySection={this.updateItemCountBySection}
              martinRecord={this.state.martinRecord}
            />
            <EmailReportSection
              ref={
                this.reportRefs !== undefined ? this.reportRefs[6] : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.email.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <NeighborsReportSection
              {...this.props}
              sectionName={this.state.navRefMap.neighbors.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <PropertiesSection
              ref={
                this.reportRefs !== undefined ? this.reportRefs[8] : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.properties.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <RelativesReportSection
              ref={
                this.reportRefs !== undefined ? this.reportRefs[9] : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.relatives.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
            />
            <SocialMediaSection
              ref={
                this.reportRefs !== undefined ? this.reportRefs[10] : undefined
              }
              {...this.props}
              sectionName={this.state.navRefMap.social.name}
              node={personResult}
              updateItemCountBySection={this.updateItemCountBySection}
                    />
            {this.state.addonReportSections}
            <br />
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    currentIndex: state.nav.currentIndex,
    stickyNav: state.stickyNav,
    userAccount: state.userAccount,
  };
}

export default connect(mapStateToProps, {
  stickyNavInitialize,
  stickyNavInitializeContext,
})(PersonReport);



// WEBPACK FOOTER //
// ./src/components/reports/PersonReport.js